// extracted by mini-css-extract-plugin
export default {"container":"hud_container__J2LQq","top-bar":"hud_top-bar__yL3Nl","bottom-bar":"hud_bottom-bar__a4rkw","menu":"hud_menu__z7ecI"};